export default "__VITE_ASSET__B6tknt7U__"